module.exports = __webpack_public_path__ + "media/images/slider_h1_03-4b013a2be7f378ee9ef069c8ec6abf91.png";